import { Inject, Injectable } from '@angular/core';
import { environment } from '../config/environment';
import { Observable } from 'rxjs';

@Injectable()
export class environmentService {

     getBaseUrl(){

        let Url =environment["BBSF_AdminUrl"]
        return Url;
     }
    

}